export const Error = 'Something went wrong.'
export const Required = 'This is required field'
export const RecordUpdated = 'Record updated successfully'
export const RecordAdded = 'Record added successfully'
export const RecordDeleted = 'Record deleted successfully'
export const SubscriberDeactivated = 'Subscriber inactivated successfully'
export const ResponseSend = 'Response Sent Successfully!'

export const DiamondImported = 'Diamond Imported Successfully!'
export const DiamondSold = 'Diamond Sold Successfully!'
export const SelectAtlestOneItem = 'Select atleast one item.'

// Popup Headers
export const Confirm = 'Confirm?'
export const ConfirmDelete = 'Delete record?'
export const ConfirmEnable = 'Are you sure you want to Active this record?'
export const ConfirmDisable = 'Are you sure you want to Inactive this record?'
export const ConfirmDeactivate = 'Inactive subscriber?'
// Popup Messages
export const MessageDelete = 'Data will not be retrieved once deleted.'
export const MessageDeactivate = 'Newsletter will not be sent to this selected email.'

// Navigation Menu
export const MenuUpdated = 'Navigation menu updated successfully'
export const MenuAdded = 'Navigation menu added successfully'
export const SitemapGenerated = 'Sitemap generated successfully'
// Oops Title
export const oops = 'Oops!'

// appointment

export const RescheduleLink = 'Reschedule Link Sent.'

export const AppointmentConfirmed = 'Appointment confirmed successfully.'
export const AppointmentRejected = 'Appointment rejected successfully.'

// Upload Images message
export const validimage = '(only .png, .jpg, .jpeg formats allowed)'
export const formatnotsupport = 'The file format is not supported.'
export const blankfile = 'Product sheet should not be blank.'
export const invalidfile = 'Invalid product sheet.'
export const pricelength = '10'
export const pricehighest = '9999999999' // 9999999999

// Error Select Group Message
export const selectgroup = 'You have to select one group to remove by click on group name.'
export const atleastonegroup = 'Default group can not be deleted.'
export const defaultgroupnotdelete = 'Default group can not be deleted.'
// Clear Cache
export const Confirmtitle = 'Clear Cache?'
export const ConfirmClear = 'Clear Cache?'
export const soldDiamondtitle = 'Mark as Sold?'
export const soldDiamondClear = 'Are you sure to do Mark as Sold?'
export const CacheClear = 'Cache Clear successfully'
export const ResetCache = 'Reset Cache successfully'
export const GenerateCache = 'Cache generated successfully'

export const ConfirmCancelNewsletter = 'Cancel Newsletter?'
export const MessageCancelNewsletter = 'Newsletter would not be sent on scheduled time.'
export const NewsletterCancelled = 'Newsletter cancelled successfully'

export const ProductImageVerified = 'Product images verified successfully'
export const SkuAlreadyExists = 'SKU already exist'

// Catlog Rule Price
export const samedate = ' Minimum difference between start date and end date should be 1hr.'
export const smalldate = 'End Date must be greater than Start Date'

// Product Price
export const updateprice = 'Product Price updated successfully'

// Widgets
export const sectionadd = 'Section added successfully'
export const sectionupdate = 'Section updated successfully'
export const sectiondeleted = 'Section deleted successfully'
export const sectionoptionadd = 'Section Option added successfully'
export const sectionoptionupdate = 'Section Option updated  successfully'

export const Reviewupdated = 'Review updated successfully'
export const MinimumSpendError = 'The minimum spend must be less than '
export const InvalidFileType = 'Invalid file'
export const RequiredSku = 'SKU is required'
export const RequiredParentSku = 'Parent SKU is required'
export const RequiredProductTitle = 'Product title is required'
export const RequiredCategory = 'Category is required'
export const RequiredWeight = 'Weight is required'
export const RequiredAttributeSet = 'Attribute set is required'
export const ProductAttributeSetDeleteError =
  "Product associated with this attribute set. So can't delete it."
export const ProductAttributeDeleteError =
  "Product associated with this attribute. So can't delete it."
export const ProductSizeDeleteError =
  "Product associated with this ProductSize. So can't delete it."
export const ProductAttributeOptionDeleteError =
  "Product associated with this option. So can't delete it."
export const RequiredPrice = 'Price is required'
export const InvalidPrice = 'Invalid price'
export const RequiredOption1Value = 'Option-1 value is required'
export const RequiredOption2Value = 'Option-2 value is required'
export const RequiredOption3Value = 'Option-3 value is required'
export const RequiredCanBeSetCarat = 'Can be set carat is required'
export const RequiredCanBeSetShape = 'Can be set shape is required'
export const SwalSectionDeleteProp = {
  title: ConfirmDelete,
  text: MessageDelete,
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}

export const SwalDeleteProp = {
  title: ConfirmDelete,
  text: MessageDelete,
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}

export const SwalDeactivateProp = {
  title: ConfirmDeactivate,
  text: MessageDeactivate,
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}

export const Swalcancelnewsletter = {
  title: ConfirmCancelNewsletter,
  text: MessageCancelNewsletter,
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}

export const CahcheclearProp = {
  title: Confirmtitle,
  text: ConfirmClear,
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}
export const diamondSoldProp = {
  title: soldDiamondtitle,
  text: soldDiamondClear,
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}
export const diamondReverSoldProp = {
  title: 'Revert Sold?',
  text: 'Are you sure, want to revert as  unsold ?',
  dangerMode: true,
  buttons: {
    cancel: true,
    danger: {
      text: 'Ok'
    }
  }
}
